import { combineReducers } from '@reduxjs/toolkit'
import { reducer as oidcReducer } from 'redux-oidc'
import { accountReducer } from 'Application/Account/store'
import VisitsReducer from 'Application/Visits/Actions/reducer'
import { commonReducer } from 'Application/Common/store'
import { commonApi } from 'Services/api'
import { accountApi } from 'Application/Account/services/api'
import { notificationReducer } from 'Application/Notification/store'
import { notificationApi } from 'Application/Notification/services/api'

const combinedReducers = combineReducers({
  [commonApi.reducerPath]: commonApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  common: commonReducer,
  account: accountReducer,
  visits: VisitsReducer,
  oidc: oidcReducer,
  notification: notificationReducer,
})

const rootReducers = (state: any, action: any) => {
  if (action.type.includes('clearAllStates')) {
    const { oidc, dashboard } = state
    state = {
      dashboard,
      oidc,
    }
  }
  return combinedReducers(state, action)
}

export default rootReducers
